// extracted by mini-css-extract-plugin
export default {"container":"qO-z","dimension":"rO-z","dimensionLabels":"sO-z"};